import { Injectable } from '@angular/core';
import { UsageType, UsageTypes } from '../../models/UIModels/UsageType';

@Injectable({
  providedIn: 'root'
})
export class UsageTypesServiceService {

  public CurrentUsageTypesList:UsageTypes;

  constructor() { 
    this.CurrentUsageTypesList = new UsageTypes();
  }

}
